import React from 'react'
import PropTypes from 'prop-types'
import { ServerContentLoader, Overlay } from './style'

const LoaderDots = ({ style = {}, size = '', overlay = false }) => {
  return (
    <>
      {overlay ? <Overlay><LoadingHtml size={size} /></Overlay> : <LoadingHtml size={size} />}
    </>
  )
}

const LoadingHtml = ({ size }) => {
  return (
    <ServerContentLoader className={`load-3 ${size}`}>
      <div className="line"></div>
      <div className="line"></div>
      <div className="line"></div>
    </ServerContentLoader>
  )
}

LoadingHtml.propTypes = {
  size: PropTypes.string
}

LoaderDots.propTypes = {
  style: PropTypes.object,
  overlay: PropTypes.bool,
  size: PropTypes.string
}

export default LoaderDots
